<template>
  <div>
    <rea-loader class="" :loading="loading"></rea-loader>
    <table class="trajectories-table table">
      <tr v-if="hasTrajectories">
        <td colspan="4">{{ uLang("app.empty_table") }}</td>
      </tr>
      <tr v-if="cardData.length > 0">
        <th>{{ uLang("app.trajectory") }}</th>
        <th>{{ uLang("app.coach") }}</th>
        <th>{{ uLang("app.start_date") }}</th>
        <th>{{ uLang("app.end_date") }}</th>
      </tr>
      <tr v-if="cardData.length > 0" v-for="traject in cardData">
        <td>
          {{ $getIfExists(traject, "trajectory.name", uLang("app.no_name")) }}
        </td>
        <td>
          {{
            traject.trajectory_manager
              ? traject.trajectory_manager.full_name
              : uLang("app.no_name")
          }}
        </td>
        <td>{{ traject.trajectory_start_date | date }}</td>
        <td>{{ traject.trajectory_end_date | date }}</td>
      </tr>
    </table>
  </div>
</template>
<script>
import { ReaLoader } from "~/components/helpers";
export default {
  name: "AllTrajects",

  components: {
    ReaLoader,
  },

  props: {
    trajectoryData: {
      required: true,
    },
    loading: {
      required: true,
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      emptyPanel: {
        trajectory: {
          name: uLang("app.no_trajectory"),
        },
        reporting_person: {
          full_name: uLang("app.no_name"),
        },
        trajectory_start_date: uLang("app.no_start_date"),
        trajectory_end_date: uLang("app.no_end_date"),
      },
    };
  },
  computed: {
    cardData() {
      if (this.hasTrajectories) {
        return this.emptyPanel;
      }

      return this.trajectoryData;
    },
    hasTrajectories() {
      return _.isEmpty(this.trajectoryData);
    },
  },
};
</script>
<style lang="scss">
table.trajectories-table {
  tr:first-child {
    td,
    th {
        text-align: left;
        border-top: none;
    }
  }
  td,
  th {
    padding-left: 0px !important;
  }
}
.action_icon {
  color: #5a4587 !important;
}
.action_icon:hover {
  color: lighten(#5a4587, 25%) !important;
}

.card-block {
  position: relative;
  min-height: 75px;
}
</style>
